import { PayloadAction, createPersistReducer, initReducer, PersistConfig } from "@grassrootly/rn-core";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { IPlayer } from "@grassrootly/api";

export interface AuthState {
  user: IPlayer | null;
}

const initialState: AuthState = {
  user: null,
};

const authSlice = initReducer({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state: AuthState, action: PayloadAction<IPlayer | null>) => {
      state.user = action.payload;
    },
  },
});

const persistConfig: PersistConfig<AuthState> = {
  key: "auth",
  storage: AsyncStorage,
};

export const authActions = authSlice.actions;

export default createPersistReducer(persistConfig, authSlice.reducer);
